import { render, staticRenderFns } from "./ShiftHistory.vue?vue&type=template&id=16d2a60d&"
import script from "./ShiftHistory.vue?vue&type=script&lang=js&"
export * from "./ShiftHistory.vue?vue&type=script&lang=js&"
import style0 from "./ShiftHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VCol,VContainer,VIcon,VImg,VListItem,VListItemContent,VListItemIcon,VProgressCircular,VRow,VSpacer,VTimeline,VTimelineItem,VTreeview})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16d2a60d')) {
      api.createRecord('16d2a60d', component.options)
    } else {
      api.reload('16d2a60d', component.options)
    }
    module.hot.accept("./ShiftHistory.vue?vue&type=template&id=16d2a60d&", function () {
      api.rerender('16d2a60d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/scheduling/ShiftHistory.vue"
export default component.exports